import axios from 'axios'
import { mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      organizationId: null,
    }
  },
  computed: {
    ...mapState('user', {
      userAllInfo: (state) => state.userAllInfo,
    }),
  },
  watch: {
    userAllInfo: {
      handler(userAllInfo) {
        if (userAllInfo?.organization_id && !this.organizationId) {
          this.organizationId = userAllInfo.organization_id
        }
      },
      deep: true,
    },
    organizationId: {
      handler() {
        this.checkRecapAvailability()
      },
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_RECAP_AVAILABILITY']),
    async checkRecapAvailability() {
      const url = `https://data-retrospectiva.pandavideo.com.br/2024/${this.organizationId}.json`
      await axios
        .get(url)
        .then(() => {
          this.UPDATE_USER_RECAP_AVAILABILITY(true)
        })
        .catch(() => {
          this.UPDATE_USER_RECAP_AVAILABILITY(false)
        })
    },
  },
}
